module.exports = __webpack_public_path__ + "media/src/images/icons/file_types/gif-a05f529f32228954287ab0898ab1b256.svg";